import React, { useState } from "react";
import { Box, Button, IconButton, Menu, MenuItem } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const RowActions = ({ onView, viewLabel = "View", menuItems = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {onView && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<VisibilityOutlinedIcon sx={{ fontSize: 16 }} />}
          onClick={onView}
          sx={{
            textTransform: "none",
            borderColor: "#e0e0e0",
            color: "text.primary",
            minWidth: "auto",
            px: 1.5,
            py: 0.5,
            fontSize: "0.8rem",
          }}
        >
          {viewLabel}
        </Button>
      )}
      {menuItems.length > 0 && (
        <>
          <IconButton
            size="small"
            onClick={(e) => setAnchorEl(e.currentTarget)}
            aria-label="More actions"
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={() => setAnchorEl(null)}
          >
            {menuItems.map((item) => (
              <MenuItem
                key={item.label}
                disabled={item.disabled}
                onClick={() => {
                  setAnchorEl(null);
                  item.onClick?.();
                }}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Box>
  );
};

export default RowActions;
